import { useTheme } from 'next-themes';

const LOGO_NEGATIVE = "https://customer-assets.emergentagent.com/job_72cddb63-0dcf-4603-8f2a-f3a5191f13d4/artifacts/x5j7516n_VALORIZA_color_negativo%206.png";
const LOGO_POSITIVE = "https://customer-assets.emergentagent.com/job_timeoff-pro-2/artifacts/osmqmhrh_VALORIZA_color_positivo.png";

export function ValorizaLogo({ height = 'h-8', className = '' }) {
  const { resolvedTheme } = useTheme();
  const src = resolvedTheme === 'dark' ? LOGO_NEGATIVE : LOGO_POSITIVE;
  return (
    <img
      src={src}
      alt="Valoriza"
      className={`${height} object-contain transition-opacity duration-300 ${className}`}
    />
  );
}
